<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger v-if="device === 'mobile'" class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div class="login-info">
      <span class="login-info-item">角色：{{ roleText }}</span>
      <span class="login-info-item">账号：{{ accountName }}</span>
    </div>
    <el-button type="text" class="logout-button" @click="logout">退出登录</el-button>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'roles'
    ]),
    accountName() {
      return this.name || '-'
    },
    roleText() {
      if (Array.isArray(this.roles) && this.roles.length > 0) {
        return this.roles.join('、')
      }
      return '-'
    },
    device() {
      return this.$store.state.app.device
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      }).catch(() => {})
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 60px;
  line-height: 60px;
  overflow: hidden;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 68px;
    height: 60px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .login-info {
    position: absolute;
    right: 186px;
    top: 0;
    height: 60px;
    line-height: 60px;
    color: #606266;
    font-size: 13px;
    white-space: nowrap;
  }
  .login-info-item {
    margin-left: 16px;
  }
  .switch-login-button {
    position: absolute;
    top: 0;
    right: 100px;
    height: 60px;
    padding: 0;
    font-size: 13px;
  }
  .logout-button {
    position: absolute;
    top: 0;
    right: 24px;
    height: 60px;
    padding: 0;
    font-size: 13px;
  }
}

.account-groups {
  min-height: 180px;
  max-height: 460px;
  overflow-y: auto;
  padding-right: 4px;
}

.account-group-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  border-radius: 12px;
  background: #f4f6f8;
  color: #303133;
}

.account-group-title span {
  color: #909399;
  font-size: 12px;
}

.account-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 10px 0 16px;
}

.account-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 58px;
  padding: 10px 14px;
  overflow: hidden;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  transition: border-color .2s;
}

.account-card:hover,
.account-card:focus-within {
  border-color: #409eff;
}

.account-card-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.account-card-main {
  display: flex;
  align-items: center;
  min-width: 0;
}

.account-platform-mark {
  flex: 0 0 auto;
  min-width: 28px;
  height: 22px;
  margin-right: 10px;
  padding: 0 6px;
  border-radius: 6px;
  background: #ecf5ff;
  color: #409eff;
  font-size: 10px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
}

.account-card-info strong,
.account-card-info span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-card-info span {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.account-card-tags {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
  white-space: nowrap;
}

.account-card-action {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, .94);
  opacity: 0;
  transition: opacity .2s;
}

.account-card:hover .account-card-action,
.account-card:focus-within .account-card-action {
  opacity: 1;
}

.account-empty {
  padding: 60px 0;
  color: #909399;
  text-align: center;
}

.switching-login {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 24px 0 34px;
  color: #303133;
  font-size: 16px;
}

.switching-login i {
  color: #409eff;
  font-size: 32px;
}

@media (max-width: 760px) {
  .account-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue